import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  withRouter,
  Link,
} from 'react-router-dom';

import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import * as routes from '../../config/routes';
import * as authActions from '../actions';
import Layout from '../../main/components/Layout';
import Alert from '../../common/components/Alert';
import FormErrorDialog from '../../common/components/formErrorDialog';
import PasswordResetForm from '../components/PasswordResetForm';
import classes from '../../css/getCSS';

class PasswordReset extends Component {
  componentDidMount() {
    document.title = 'Reset your password';
  }

  componentWillUnmount() {
    this.props.onUnmount();
  }

  inputChangedHandler = (event, field) => {
    this.props.inputChangedHandler(
      event,
      field,
      'passwordResetForm',
      this.props.inputs,
    );
  }

  submitHandler = (event) => {
    this.props.initiatePasswordReset(
      event,
      'passwordResetForm',
      this.props.inputs,
    );
  }

  render() {
    let displayForm = (
      <form method="post" onSubmit={this.submitHandler}>
        <PasswordResetForm
          inputs={this.props.inputs}
          inputChangedHandler={this.inputChangedHandler}
        />
      </form>
    );

    if (this.props.loading) {
      displayForm = (
        <div align="center"><CircularProgress align="center" size={50} /></div>
      );
    }

    let nonFieldErrors = null;
    if (this.props.errors) {
      nonFieldErrors = this.props.errors.map((error) => {
        return (
          <Alert key={error} type="danger">{error}</Alert>
        );
      });
    }

    let successMsg = null;
    if (this.props.success) {
      successMsg = <Alert type="success">{this.props.success}</Alert>;
    }

    return (
      <Layout hideNavbar rootClass={[classes.loginBack].join(' ')} background>
        <Grid container style={{ justifyContent: 'center' }}>
          <Grid item md={4} xs={12} sm={5} className={classes.padding15XS}>
            <Paper className={[classes.card].join(' ')}>
              <br />
              <Typography variant="title" style={{ color: '#666' }}>Reset your password</Typography>
              <br />
              {nonFieldErrors}
              {successMsg}
              <br />
              {displayForm}
              <br />
              <Typography variant="body1"><Link to={routes.LOGIN}>Back to Login</Link></Typography>
            </Paper>
          </Grid>
        </Grid>
        <FormErrorDialog open={this.props.hasError} handleClose={this.props.toggleError} />
      </Layout>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    inputs: state.auth.passwordResetForm,
    hasError: state.auth.hasError,
    errors: state.auth.errors,
    success: state.auth.success,
    loading: state.auth.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleError: () => dispatch(authActions.toggleError()),
    inputChangedHandler: (event, field, form, inputs) => dispatch(
      authActions.inputChangedHandler(event, field, form, inputs),
    ),
    initiatePasswordReset: (event, form, inputs) => dispatch(
      authActions.initiatePasswordReset(event, form, inputs),
    ),
    onUnmount: () => dispatch(authActions.onUnmount()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PasswordReset));



// WEBPACK FOOTER //
// ./src/auth/containers/PasswordReset.js